export default "__VITE_ASSET__BZsXCEZK__"